import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { Col, Row, Spin } from 'antd';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { useQuery } from '@tanstack/react-query';

import styled from 'styled-components';

import ApplicationSidebar from './application_sidebar/ApplicationSidebar';
import ApplicationSummary from './application_summary/ApplicationSummary';

import { getCotenant } from './api/cotenants';

const StyledMobileCol = styled(Col)`
  margin-bottom: 12px;
`;
const StyledSpinner = styled(Spin)`
  margin: auto;
  width: 100%;
  margin-top: 42px;
`;

const ApplicationPortal = ({ cotenantId }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const { data: cotenant, isLoading } = useQuery({
    queryKey: ['cotenant', cotenantId],
    retry: false,
    staleTime: 120000,
    queryFn: () => getCotenant(cotenantId).then((res) => res.cotenant),
  });

  return (
    <>
      {isLoading ? (
        <StyledSpinner />
      ) : (
        <>
          <Row gutter={16}>
            {isMobile ? (
              <>
                <StyledMobileCol className="gutter-row" span={24}>
                  <ApplicationSidebar cotenantId={cotenantId} />
                </StyledMobileCol>
                <Col className="gutter-row" span={24}>
                  <ApplicationSummary cotenantId={cotenantId} cotenant={cotenant} />
                </Col>
              </>
            ) : (
              <>
                <Col className="gutter-row" span={16}>
                  <ApplicationSummary cotenantId={cotenantId} cotenant={cotenant} />
                </Col>
                <Col className="gutter-row" span={8}>
                  <ApplicationSidebar cotenantId={cotenantId} />
                </Col>
              </>
            )}
          </Row>
        </>
      )}
    </>
  );
};

export default withRouter(ApplicationPortal);
